var _defs, _circle, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3, _path4, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegionalInsightsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-5 h-5",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "globeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#0055A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#003D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "continentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E32934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6B75"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowRadial",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD700",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFD700",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 3,
    floodOpacity: 0.3
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#glowRadial)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "url(#globeGradient)",
    filter: "url(#shadow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 24,
    ry: 8,
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    opacity: 0.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 24,
    ry: 16,
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 8,
    ry: 24,
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    opacity: 0.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 32,
    rx: 16,
    ry: 24,
    fill: "none",
    stroke: "white",
    strokeWidth: 1,
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20 20 Q 22 18 26 20 T 30 22 L 28 26 Q 24 28 20 26 Z",
    fill: "url(#continentGradient)",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 36 16 Q 40 14 44 16 L 46 20 Q 44 24 40 24 L 36 20 Z",
    fill: "url(#continentGradient)",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 18 34 L 22 32 Q 26 32 28 36 L 26 40 Q 22 42 18 40 Z",
    fill: "url(#continentGradient)",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 38 36 Q 42 34 46 36 L 48 42 Q 44 44 40 42 Z",
    fill: "url(#continentGradient)",
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 2,
    fill: "#FFD700",
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 20,
    r: 2,
    fill: "#FFD700",
    opacity: 0.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 38,
    r: 2,
    fill: "#FFD700",
    opacity: 0.9
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 4,
    fill: "white",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionalInsightsIcon);
export default __webpack_public_path__ + "static/media/regional-insights-icon.343155cc88c8bf20735cabd02f968ff8.svg";
export { ForwardRef as ReactComponent };